export default __webpack_public_path__ + "static/media/Veeva_My-Engage-ja.c2a8f829.mp4";